'use strict';

namespace TR {

    class PriceRefresh {

        dataForPup: any;
        paymentAmount: any;
        depositAmount: any;

        constructor (
            private $location: ng.ILocationService,
            private $scope: any,
            private modalService: any,
            private broker: Core.Broker,
            private $route: ng.route.IRouteService,
            private savedSearchService: any,
            private occupancyService: Core.OccupancyService,
            private basketService: any,
            private analytics: any
        ) {
            this.dataForPup = modalService.get('dataForPup');
            if (this.dataForPup) {
                this.paymentAmount = this.dataForPup.totalCostGrouped + (this.dataForPup.cardFeeForTotal || 0);
                this.depositAmount = this.dataForPup.hasDeposit ?
                    this.dataForPup.totalDeposit + (this.dataForPup.cardFeeForDeposit || 0) : 0;
            }
        }

        confirmBooking (): void {
            this.analytics.track('mixpanel', 'PUPNAVL Pop-up Interaction', { Type: 'PUP',
                PUPAmount: this.dataForPup.pupAmount, CTA: 'Accept and continue' });
            this.modalService.close();
            this.broker.publish('confirmPUP', {paymentAmount: this.paymentAmount, depositAmount: this.depositAmount,
                basketId: this.dataForPup.basketId});
        }

        restoreSearch (): void {
            const popupType = this.modalService.get('popupType');
            if (popupType === 'PUP') {
                this.analytics.track('mixpanel', 'PUPNAVL Pop-up Interaction', { Type: popupType,
                    PUPAmount: this.dataForPup.pupAmount, CTA: 'Back to search' });
            } else {
                this.analytics.track('mixpanel', 'PUPNAVL Pop-up Interaction', { Type: popupType,
                    CTA: 'Back to search' });
            }
            this.savedSearchService.getSavedSearches().then((searches) => {
                let mostRecent: any = _.head(searches);
                if (mostRecent == null && this.$route.current) {
                    this.$location.path(`/${this.$route.current.area}`);
                } else {
                    if (mostRecent.Rooms) {
                        mostRecent.occupancyStr = this.occupancyService.getOccupancyString(mostRecent.Rooms);
                    }
                    this.$scope.$emit('block', {
                        title: null,
                        loadingScreenStyle: 'default-notFoundCtrl'
                    });
                    this.savedSearchService.restoreSearch(mostRecent).then(() => {
                        this.basketService.startWorkflow(this.basketService.workflowType[mostRecent.SearchType]);
                    });
                }
            });
        }
    }

    angular
        .module('TR')
        .controller('PriceRefresh', PriceRefresh);
}
